import React from 'react';
var ToastContext = React.createContext({
  onClose: function onClose() {}
});
export default ToastContext;